import Vue from 'vue';
import Vuex from 'vuex';

import VuexPersistence from 'vuex-persist/dist/umd';

import style from './modules/style.js'
import display from './modules/display.js'

import { fetchPaymentInformation, requestCardPayment } from '../api/payment.js'

Vue.use(Vuex);

const vuexLocal = new VuexPersistence({
  storage: window.localStorage,
  key: 'public-handwritten-payment'
})

export default new Vuex.Store({
  modules: {
    style,
    display
  },
  state: {
    paymentQuery: {
      api_key: '',
      order_no: '',
      token: ''
    },
    paymentInformation: {
      
    },
    overseasPaymentType: '',
    paymentResult: {},
    error: {
      messaage: '',
      code: ''
    },
    redirect: {
      success: '',
      failure:''
    }
  },
  getters: {
    GET_PAYMENT_INFORMATION(state) {
      return state.paymentInformation;
    },
    GET_PAYMENT_QUERY(state) {
      return state.paymentQuery;
    },
    GET_OVERSEAS_PAYMENT_TYPE(state) {
      return state.overseasPaymentType;
    },
    GET_PAYMENT_RESULT(state) {
      return state.paymentResult;
    },
    GET_ERROR_MSG(state) {
      return state.error;
    },
    GET_REDIRECT(state) {
      return state.redirect;
    }
  },
  mutations: {
    SET_PAYMENT_INFORMATION(state, data) {
      state.paymentQuery = data.query;
      state.paymentInformation = data.data;

      if(data && data.payload && data.payload.error_url) {
        state.redirect.success = data.payload.success_url;
        state.redirect.failure = data.payload.error_url;
      }
    },
    SET_OVERSEAS_PAYMENT_TYPE(state, data) {
      state.overseasPaymentType = data
    },
    SET_PAYMENT_RESULT(state, data) {
      state.paymentResult = data;
    },
    SET_ERROR_MSG(state, data) {
      state.error = data
    }
  },
  actions: { 
    async FETCH_PAYMENT_INFORMATION(context, data) {
      try {
        console.log("auth", data)
        let res = await fetchPaymentInformation(data);
        context.commit('SET_PAYMENT_INFORMATION', { query: data, data: res.data })
  
        return res;        
      } catch (error) {
        return error;
      }
    },
    async SET_OVERSEAS_PAYMENT_TYPE(context, data) {
      let promise = new Promise((resolve, reject) => {
        if(!data) {
          reject();
        }
  
        context.commit('SET_OVERSEAS_PAYMENT_TYPE', data);
  
        resolve();
      });
  
      return promise;
    },
    async REQUEST_CARD_PAYMENT(context, data) {
      let paymentInformation = context.getters.GET_PAYMENT_INFORMATION;
      let paymentQuery = context.getters.GET_PAYMENT_QUERY;
      
      let res = await requestCardPayment({ ...data, ...paymentInformation, ...paymentQuery });
      context.commit("SET_PAYMENT_RESULT", res.data)

      return res;
    },
    SET_ERROR_PAGE(context, data) {
      console.log('error')
      let promise = new Promise((resolve, reject) => {
        if(!data) {
          reject();
        }
  
        context.commit('SET_ERROR_MSG', data);
        resolve();
      });
      return promise;
    },
    async DETECT_PAYMENT_INFORMATION(context) {
      let data = context.getters.GET_PAYMENT_QUERY;

      try {
        let res = await fetchPaymentInformation(data);

        return res;
      } catch (error) {
        return error;
      }
    }
  },
  plugins: [vuexLocal.plugin]
})
